


























































































































































import { Component, Prop, Vue } from "@/shared/vuepack";
import { HsabPayee } from "@/shared/types";
import { usePayeeStore } from "@/employer/store/payee";
import _ from "lodash";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

const blankPayee: HsabPayee = {
  payeeId: null,
  payeeName: "",
  memberAccountNumber: "",
  address1: "",
  address2: "",
  city: "",
  stateCode: "",
  zip: ""
};

const enum SelectorState {
  uninitialized,
  Searching,
  Selected,
  Editing,
  Creating,
}

@Component({
  components: { GenericLoadingSpinner }
})
export default class PayeeSelector extends Vue {

  payeeStore = usePayeeStore();

  @Prop({default: null})
  initialPayee: HsabPayee;

  @Prop()
  readonly: boolean;

  selectedPayee: HsabPayee = null;

  currentState: SelectorState = SelectorState.uninitialized;
  searchTerm = "";
  editingPayee: HsabPayee = {...blankPayee};

  get showSearch () {
    return !this.payeeStore.isFetchingLoading && this.currentState === SelectorState.Searching;
  }

  get showCreate () {
    return !this.payeeStore.isFetchingLoading && this.currentState === SelectorState.Creating;
  }

  get showEdit () {
    return !this.payeeStore.isFetchingLoading && this.currentState === SelectorState.Editing;
  }

  get showSelectedPayee () {
    return !this.payeeStore.isFetchingLoading &&
        this.selectedPayee &&
        this.currentState === SelectorState.Selected;
  }

  get showEditButton () {
    return this.currentState === SelectorState.Selected &&
        this.selectedPayee &&
        this.selectedPayee.payeeId &&
        this.selectedPayee.payeeId > 0 &&
        !this.readonly;
  }

  get showClearButton () {
    return this.currentState === SelectorState.Selected &&
        this.selectedPayee &&
        !this.readonly;
  }

  get showCreateNewPayeeButton () {
    return this.currentState === SelectorState.Searching &&
        !this.readonly;
  }

  get showMainLoader () {
    return this.payeeStore.isFetchingLoading;
  }

  mounted () {
    const selectedPassedInAsProp = this.initialPayee !== null && this.initialPayee.payeeName;
    if (selectedPassedInAsProp) {
      this.selectedPayee = _.cloneDeep(this.initialPayee);
      this.currentState = SelectorState.Selected;
    }

    this.payeeStore.LoadPayees().then(
        () => {
          if (!selectedPassedInAsProp) {
            this.currentState = SelectorState.Searching;
          }
        }
    );
  }

  onCancelCreateOrEditClicked () {
    this.resetEditingPayee();
    if (this.selectedPayee && this.selectedPayee.payeeName) {
      this.currentState = SelectorState.Selected;
    } else {
      this.currentState = SelectorState.Searching;
    }
    this.$emit("is-editing", false);
  }

  onEditSelectedPayeeClicked () {
    this.currentState = SelectorState.Editing;
    this.editingPayee = _.cloneDeep(this.selectedPayee);
    this.$emit("is-editing", true);
  }

  onCreateNewPayeeClicked () {
    this.currentState = SelectorState.Creating;
    this.resetEditingPayee();
    this.$emit("is-editing", true);
  }

  onSaveChangesClicked () {
    this.payeeStore.savePayee(this.editingPayee).then(p => {
      if (p) {
        this.selectedPayee = p;
        this.$emit("payee-selected", p);
        this.currentState = SelectorState.Selected;
        this.$emit("is-editing", false);
      }
    });
  }

  onCreatePayeeClicked () {
    this.payeeStore.createPayee(this.editingPayee).then(p => {
      if (p) {
        this.selectedPayee = p;
        this.$emit("payee-selected", p);
        this.currentState = SelectorState.Selected;
        this.$emit("is-editing", false);
      }
    });
  }

  onClearSelectedPayee () {
    this.selectedPayee = null;
    this.currentState = SelectorState.Searching;
    this.$emit("payee-selected", null);
  }

  onPayeeSelected (item) {
    this.selectedPayee = item;
    this.$emit("payee-selected", item);
    this.searchTerm = "";
    this.currentState = SelectorState.Selected;
  }

  resetEditingPayee () {
    this.editingPayee.payeeId = null;
    this.editingPayee.payeeName = "";
    this.editingPayee.memberAccountNumber = "";
    this.editingPayee.address1 = "";
    this.editingPayee.address2 = "";
    this.editingPayee.city = "";
    this.editingPayee.stateCode = "";
    this.editingPayee.zip = "";
  }

  formatPayeeAddressToString (payee: HsabPayee) {
    let result = payee.address1;

    if (payee.address2) {
      result += ", " + payee.address2;
    }

    if (payee.city && payee.stateCode && payee.zip) {
      result += ` ${payee.city}, ${payee.stateCode} ${payee.zip}`;
    }
    return result;
  }

  payeeFormatForSearch (payee) {
    return payee.payeeName;
  }
}
